var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c(
        "line-control",
        _vm._b(
          {
            scopedSlots: _vm._u(
              [
                {
                  key: "indicator",
                  fn: function(slotProps) {
                    return [
                      _vm._t("indicator", null, {
                        line: slotProps.line,
                        title: slotProps.title
                      })
                    ]
                  }
                },
                {
                  key: "totalIndicator",
                  fn: function() {
                    return [_vm._t("totalIndicator")]
                  },
                  proxy: true
                }
              ],
              null,
              true
            ),
            model: {
              value: _vm.value,
              callback: function($$v) {
                _vm.value = $$v
              },
              expression: "value"
            }
          },
          "line-control",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _vm._l(_vm.lineWrappers, function(wrapper, index) {
        return wrapper.requireExplanation()
          ? _c("text-area-row", {
              key: _vm.$attrs.id + "-details-" + index,
              attrs: {
                id: _vm.$attrs.id + "-wrapper-" + index,
                rows: 5,
                maxLength: 500,
                title: wrapper.key + "_Details",
                required: true,
                placeholder: "Placeholder.TextArea"
              },
              model: {
                value: wrapper.description,
                callback: function($$v) {
                  _vm.$set(wrapper, "description", $$v)
                },
                expression: "wrapper.description"
              }
            })
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }